import { Alert, ButtonANTD, Spin } from '@zennolab_platform/webui-kit/dist/ui/antdComponents';
import { useFormatMessage } from '@zennolab_platform/webui-sdk/dist/hooks';

import type { IApiError } from '../../services/apiError';
import { Centered } from '../layout';

export function Checking() {
  const { t } = useFormatMessage();
  return (
    <Centered data-testid="checking">
      <Spin />
      <p>
        {t({ id: 'shell.session.checking', defaultMessage: 'Проверяем сессию…', description: 'Экран проверки сессии' })}
      </p>
    </Centered>
  );
}

export function NoAccess() {
  const { t } = useFormatMessage();
  return (
    <Centered>
      <h1>
        {t({
          id: 'shell.noAccess.title',
          defaultMessage: 'Нет доступа',
          description: 'Заголовок экрана и ошибка при отказе в доступе',
        })}
      </h1>
      <p>
        {t({
          id: 'shell.noAccess.text',
          defaultMessage: 'У вашей учётной записи нет роли для этого раздела.',
          description: 'Текст экрана «Нет доступа»',
        })}
      </p>
    </Centered>
  );
}

export function NotFound() {
  const { t } = useFormatMessage();
  return (
    <Centered>
      <h1>
        {t({ id: 'shell.notFound.title', defaultMessage: 'Страница не найдена', description: 'Заголовок экрана 404' })}
      </h1>
    </Centered>
  );
}

export function NotConfigured({ names }: { names: string[] }) {
  const { t } = useFormatMessage();
  return (
    <Centered>
      <h1>
        {t({
          id: 'shell.notConfigured.title',
          defaultMessage: 'Приложение не настроено',
          description: 'Заголовок экрана об отсутствующих переменных окружения',
        })}
      </h1>
      <p>
        {t(
          {
            id: 'shell.notConfigured.text',
            defaultMessage: 'Не заданы переменные: {names}',
            description: 'Текст экрана о ненастроенном приложении; names — имена переменных',
          },
          { names: names.join(', ') },
        )}
      </p>
    </Centered>
  );
}

export function ErrorAlert({ error, onRetry }: { error: IApiError; onRetry: () => void }) {
  const { t } = useFormatMessage();
  return (
    <Alert
      type="error"
      title={
        error.kind === 'network'
          ? t({
              id: 'shell.error.network',
              defaultMessage:
                'Не удалось связаться с сервисом анонсов. Проверьте подключение к сети и повторите попытку.',
              description: 'Ошибка сети при загрузке или сохранении',
            })
          : t(
              {
                id: 'shell.error.generic',
                defaultMessage: 'Не удалось выполнить запрос: {message}',
                description: 'Ошибка запроса; message — текст ошибки',
              },
              { message: error.message },
            )
      }
      action={
        <ButtonANTD onClick={onRetry}>
          {t({
            id: 'shell.common.retry',
            defaultMessage: 'Повторить',
            description: 'Кнопка повтора запроса или проверки сессии',
          })}
        </ButtonANTD>
      }
    />
  );
}
